/**
 * Truncates text to a maximum length while preserving whole words
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length (default: 280)
 * @returns {string} The truncated text with '...' appended if truncated
 */
export function truncateText(text, maxLength = 280) {
    if (!text || text.length <= maxLength) {
        return text
    }

    // Account for the '...' that will be added (3 characters)
    const targetLength = maxLength - 3

    // Split on whitespace and build up the truncated string word by word
    const truncated = text.split(/\s+/).reduce((acc, word) => {
        // Check if adding this word (plus a space) would exceed the limit
        if (acc.length + word.length + 1 <= targetLength) {
            return acc.length ? `${acc} ${word}` : word
        }
        return acc
    }, '')

    return truncated + '...'
}
